/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from "react";

export const RenderValidationError: FC<any> = ({ children }: any) => (
    children && (
        <p className="help is-danger" style={{ fontSize: '14px' }}>{children}</p>
    )
);
